import axios from 'axios';

const API_BASE_URL = '/api/proxy'; // Use proxy endpoint instead of direct API calls

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
  },
});

// Store auth0 methods reference for user authentication (still needed for user access control)
let auth0Methods = null;

export const setAuth0Methods = (methods) => {
  auth0Methods = methods;
};

// Request interceptor - proxy will handle service account authentication
api.interceptors.request.use(
  async (config) => {
    console.log('Making API request via proxy to:', config.url);
    
    // Verify user is authenticated with Auth0 (for access control)
    if (auth0Methods && auth0Methods.getAccessTokenSilently) {
      try {
        const token = await auth0Methods.getAccessTokenSilently();
        if (!token) {
          console.warn('No Auth0 token available - user may need to re-authenticate');
          // Could redirect to login here if needed
        }
      } catch (error) {
        console.error('Auth0 authentication check failed:', error);
        // Continue with request but user might need to login
      }
    }
    
    // Don't add any authorization header - proxy will add service account token
    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    console.log(`API Response [${response.status}]:`, response.config.url);
    return response;
  },
  async (error) => {
    const status = error.response?.status;
    const url = error.config?.url;
    
    console.error(`API Error [${status}] for ${url}:`, error.response?.data || error.message);
    
    // Handle 401 Unauthorized - could be service account issue or user session expired
    if (status === 401) {
      console.error('Authentication failed - 401 Unauthorized');
      if (auth0Methods && auth0Methods.loginWithRedirect) {
        console.warn('Redirecting to login');
        auth0Methods.loginWithRedirect();
      }
      return Promise.reject(error);
    }
    
    // Handle 403 Forbidden
    if (status === 403) {
      console.error('Forbidden - 403 Access denied');
    }
    
    // Handle 304 Not Modified
    if (status === 304) {
      console.log('304 Not Modified - using cached response');
    }
    
    // Handle other errors
    const message = error.response?.data?.detail || error.message || 'An error occurred';
    error.message = message;
    return Promise.reject(error);
  }
);

export default api; 